<template>
    <div class="gyl-dialog" data-transfer="true">
        <transition :name="transitionNames[1]">
            <div class="ivu-modal-mask" :style="wrapStyles" v-show="visible" v-if="showMask" @click="handleMask"></div>
        </transition>
        <div class="gyl-dialog-wrap" :style="wrapStyles" v-show="visible" @click="handleWrapClick">
            <transition :name="transitionNames[0]">
                <div class="gyl-dialog-content" :style="mainStyles" v-show="visible">                   
					<div class="gyl-dialog-title" v-if="showHead"><slot name="header">{{ title }}</slot></div>
					<slot></slot>
                </div>
            </transition>
        </div>
    </div>
</template>
<script>
export default {
	name: 'Dialog',
	props: {
		value: {//
			type: Boolean,
			default: false
		},
		title: {//
			type: String
		},
		width: {//
			type: [Number, String],
			default: 520
		},
		styles: {//
			type: Object
		},
		transitionNames: {//
			type: Array,
			default () {
				return ['ease', 'fade'];
			}
		},
		mask: {//
			type: Boolean,
			default: true
		},		
		zIndex: {//
			type: Number,
			default: 1000
		},
	},
	data () {
		return {
			wrapShow: false,//
			showHead: true,//
			visible: this.value,//
			index:0,
			modalIndex: this.handleGetModalIndex()// 
		};
	},
	computed: {
		wrapStyles () {//
			return {
				zIndex: this.modalIndex + this.zIndex
			};
		},
		mainStyles () {//
			let style = {};

			const width = parseInt(this.width);
			const styleWidth = {
				width: width <= 100 ? `${width}%` : `${width}px`
			};

			const customStyle = this.styles ? this.styles : {};

			Object.assign(style, styleWidth, customStyle);

			return style;
		},
		showMask () {//
			return this.mask;
		}
	},
	methods: {
		close () {//
			this.visible = false;
		},
		handleMask () {//
			if (this.showMask) {
				this.close();
			}
		},
		handleWrapClick (event) {//
			// use indexOf,do not use === ,because ivu-modal-wrap can have other custom className
			const className = event.target.getAttribute('class');
			if (className && className.indexOf('ivu-dialog-wrap') > -1) this.handleMask();
		},
		handleGetModalIndex () {//			
			return this.index++;
		}
	},
	mounted () {
		if (this.visible) {//
			this.wrapShow = true;
		}

		let showHead = true;//

		if (this.$slots.header === undefined && !this.title) {//
			showHead = false;
		}

		this.showHead = showHead;//
		
	},
	watch: {
		value (val) {//
			this.visible = val;
		},
		visible (val) {//
			if (val === false) {	
				this.timer = setTimeout(() => {
					this.wrapShow = false;					
				}, 300);
			} else {
				this.modalIndex = this.handleGetModalIndex();

				if (this.timer) clearTimeout(this.timer);
				this.wrapShow = true;
			}
		},
		title (val) {//
			if (this.$slots.header === undefined) {
				this.showHead = !!val;
			}
		},
	}
};
</script>



// WEBPACK FOOTER //
// src/components/inc/modal/dialog.vue